import type { ReactNode } from "react";
import { FlowUIProvider } from "@akin2unde/flowui-react";
import { CreatePantryStackTheme } from "../theme/PantryStackTheme";
import { useTenant } from "./useTenant";

interface TenantThemeProviderProps {
  children: ReactNode;
}

export default function TenantThemeProvider({
  children,
}: TenantThemeProviderProps) {
  const { Theme } = useTenant();

  return (
    <FlowUIProvider theme={CreatePantryStackTheme(Theme)} mode="light">
      {children}
    </FlowUIProvider>
  );
}
